import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import useCreatePlaylist from "./useCreatePlaylist";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import GeneralEditPlaylistForm from "../utils/GeneralEditPlaylistForm";
import {useIntl} from "react-intl";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";

const NewPlaylistSection = () => {
    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the new user functionality
    const {create, saveInProgress, cancel} = useCreatePlaylist()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedPlaylistRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({
                id: 'app.playlists.new.appbar.header',
                defaultMessage: 'Create New Playlist'
            }),
            description: intl.formatMessage({
                id: 'app.playlists.new.appbar.description',
                defaultMessage: 'Compose a new playlist'
            }),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.playlists.new.appbar.actions.save',
                        defaultMessage: 'Save'
                    })}
                    onClick={() => create(editedPlaylistRef.current)}
                    icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.playlists.new.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, saveInProgress])

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.playlists.new.save.loading',
                defaultMessage: 'Creating Playlist...'
            })}/>
    }

    return (
        <GeneralEditPlaylistForm editedPlaylistRef={editedPlaylistRef}
                                 setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default NewPlaylistSection